import { type Enum } from '@webapp/infrastructure/types/Enum'

export const CardDisplayStatuses = {
  ACTIVE: 'active',
  PENDING: 'pending',
  LOCKED: 'locked',
  CANCELED: 'canceled',
  UNKNOWN: 'unknown',
} as const

export type CardDisplayStatusEnum = Enum<typeof CardDisplayStatuses>
